<template>
  <div class="dzdh-container">
    <img :src="dataSource.value" alt="" />
  </div>
</template>

<script>
export default {
  name: "dzdh-container",
  props: {
    dataSource: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {};
  },
  methods: {}
};
</script>

<style lang="less" scoped>
.dzdh-container {
  position: relative;
  z-index: 1;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  img {
    width: 476px;
    height: 100%;
    object-fit: cover;
  }
}
</style>
